import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XDiv, XUl, XLi, XI, XA, XSpan} from "../Layout/Layout";
import Navbar from "../Navbar/Navbar"; 
import getChilds from "../Children/Children";
import DataTableApi from "../Table/Api/DataTableApi";
import DataStruct from "./DataStruct";
import Plane from "../Loading/Plane";
import TableManager from "../Table/TableManager";
import Pagination from "../Pagination/Pagination";
import Eventer from "../Event/Eventer";
import DropDown from "../Sidebar/DropDown";
import CheckBox from "../Input/CheckBox";
import Interface from "../Interface";
import DataExcelApi from "../Table/Api/DataExcelApi";
import { MCbrowser } from "../../../app/Context/browserContext";

class  DataLoader extends Component{

    constructor(props) {
        super(props);

        this.isAlive=true;
        this.data=[];
        this.dataStruct=new DataStruct();

        this.navbarChilds=getChilds(props.children,"navbar");
        this.linksChilds=getChilds(props.children,"links");

        this.getLoadData = this.loadUp.bind(this);
        this.HselectClick = this.selectClick.bind(this);
        this.HrefreshClick = this.refreshClick.bind(this);
        this.HlengthClick10 = this.lengthClick.bind(this,10);
        this.HlengthClick25 = this.lengthClick.bind(this,25);
        this.HlengthClick50 = this.lengthClick.bind(this,50);
        this.HlengthClick100 = this.lengthClick.bind(this,100);
        this.HpageClick = this.pageClick.bind(this);
        this.HsearchClick = this.searchClick.bind(this);
        this.HcloseFilters = this.closeFiltersClick.bind(this);
        this.HcloseFilter = this.closeFilter.bind(this);
        this.Hrefresh = this.refresh.bind(this);
        this.HselectItemClick = this.selectItemClick.bind(this);
        this.HexcelDownload = this.excelDownload.bind(this);
        this.HexcelExport = this.excelExport.bind(this);

        this.state = {render:false,resultText:"",resultState:"first",filters:props.queryFilters,listFilters:props.listFilters,
            objTable:{start:0, length:props.lengthTable, order_column:props.orderColumn, order_dir:props.orderDir}};

        this.wrapper=React.createRef();
        this.selectLength=React.createRef();
        this.pager=React.createRef();
        this.selectAll=React.createRef();

        this.props=props;
        this.isExcelRun=false;
        if(Interface.isEmptyString(props.excelUrl)){
            this.excelXLi=null;
        }else {
            this.excelXLi = <XLi className="nav-item ">
                <XA className="nav-link" href="#" onClick={this.HexcelDownload}>
                    <XI className="la la-file-excel"/>
                </XA>
            </XLi>;
        }
    }

    selectItemClick(evt) {
        let str=evt.target.closest(".data-item-box").dataset.recordkey;
        let id=parseInt(str);
        if(id>0){
            let checked=evt.target.checked;
            if(checked){
                var mySet = new Set(this.dataStruct.selected);
                if(!mySet.has(id)){
                    this.dataStruct.selected.push(id);
                }
            }else{
                var index = this.dataStruct.selected.indexOf(id);
                if (index !== -1) this.dataStruct.selected.splice(index, 1);
            }
            if(this.dataStruct.selected.length===this.dataStruct.rows.length){
                if(this.dataStruct.rows.length>0){
                    this.selectAll.current.setChecked(false);
                }
            } else{
                this.selectAll.current.setUnChecked(false);
            }
        }
    }

    selectClick(event) {
        event.preventDefault();
        event.stopPropagation();
        let checked=event.target.checked;
        if(checked){
            this.dataStruct.selected=[];
        }else{
            this.dataStruct.selected=[];
        }
        var items = this.wrapper.current.querySelectorAll("div.data-item-box>div.item-links>div.selector>input[type='checkbox']");
        items.forEach(function(item) {
            item.checked= checked;
            Eventer.triggerEvent( item,"change");
        });

        return false;
    }

    getSelectedData(){
        return this.dataStruct.selected;
    }

    closeFilter(event) {
        event.preventDefault();
        event.stopPropagation();
        let filteridStr=event.currentTarget.getAttribute('filterid');
        let filterid=parseInt(filteridStr);
        if(filterid>0) {
            let l=this.dataStruct.filtersIndex.length;
            for (let i=0;i<l;i++){
                if(this.dataStruct.filtersIndex[i]===filterid){
                    this.dataStruct.filtersIndex.splice(i, 1);
                    this.dataStruct.filters.splice(i, 1);
                    break;
                }
            }
        }
        
        let pn=event.currentTarget.getAttribute('pn');
        let listFilters=this.state.listFilters;
        delete listFilters[pn];
        let filters=this.state.filters;
        let fs=JSON.parse( filters);
        
        if(fs.hasOwnProperty(pn)){
            delete fs[pn];
        }else{
            let az="az_"+pn;
            if(fs.hasOwnProperty(az)){
                delete fs[az];
            }
            let ta="ta_"+pn;
            if(fs.hasOwnProperty(ta)){
                delete fs[ta];
            }
        }
        filters=JSON.stringify(fs);
         
        this.setState({resultState: "refresh", filters: filters, listFilters: listFilters});
        return false;
    }

    closeFiltersClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dataStruct.filters=[];
        this.dataStruct.filtersIndex=[];
        this.setState({ resultState: "refresh",filters:"",listFilters:{}});
        return false;
    }

    lengthClick(length,event) {
        event.preventDefault();
        event.stopPropagation();
        let page=this.pager.current.setPageSize(length);
        let start=(page-1)*this.state.objTable.length;
        this.setState((prevState) => ({ resultState: "refresh",objTable: {...prevState.objTable,start:start,length:length }  }));
        return false;
    }

    searchClick(searchData) {
        let filtersLoad=searchData.LoadSearch;
        let filters=searchData.FilterSearch;
        TableManager.initFilters(filters,this.dataStruct,this.HcloseFilter);
        let start=0;
        this.pager.current.setTotal(0);
        this.setState((prevState) => ({ resultState: "refresh",filters:filtersLoad,listFilters:filters,
            objTable: {...prevState.objTable,start:start }  }));
    }

    pageClick(page) {
        let start=(page-1)*this.state.objTable.length;
        this.setState((prevState) => ({ resultState: "refresh",objTable: {...prevState.objTable,start:start }  }));
    }

    refreshClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.refresh();
        return false;
    }

    refresh() {
        if (this.state.resultState!=="loading") {
            this.setState({ resultState: "refresh"});

            this.dataStruct.selectedCheckBox.forEach(function(item) {
                item.current.setUnChecked(false);
            });
        }
    }

    refreshRender() {
        let r=!this.state.render;
        this.setState({render: r});
    }

    excelExport($response){
        if($response instanceof  Object) {
            if ($response.hasOwnProperty("file")) {
                //let contentType = $response.file["type"];
                let filename = $response.file["name"];
                let uri = $response.file["text"];
                var link = document.createElement("a");
                link.download = filename;
                link.href = uri;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        this.isExcelRun=false;
        this.excelXLi = <XLi className="nav-item ">
            <XA className="nav-link" href="#" onClick={this.HexcelDownload}>
                <XI className="la la-file-excel"/>
            </XA>
        </XLi>;
        this.refreshRender();
    }

    excelDownload(){
        if(!this.isExcelRun ){
            this.excelUp(this.HexcelExport);
        }
    }

    excelUp(callback) {
        this.isExcelRun=true;
        this.excelXLi = <XLi className="nav-item ">
            <XA className="nav-link" href="#"  >
                <XI className="la la-spinner icn-spinner"/>
            </XA>
        </XLi>;
        this.refreshRender();
        let pageAlerts = this.props.pageAlerts;
        DataExcelApi(this.props.baseUrl,this.props.excelUrl, this.props.queryFields,
            this.props.queryArgs,pageAlerts,this.state.objTable,this.state.filters,callback);
    }

    async loadUp() {
        let pageAlerts = this.props.pageAlerts;
        this.dataStruct.rows=[];
        this.dataStruct.selected=[];

        let resTable=await DataTableApi(this.props.srcName,this.props.queryFields,this.props.queryArgs,pageAlerts,this.state.objTable,this.state.filters);
        if(this.isAlive) {
            let start = this.state.objTable.start;
            if (resTable.hasOwnProperty("recordsTotal")) {
                let t = resTable["recordsTotal"];
                this.dataStruct.totalNumber = parseInt(t);
                let total=this.dataStruct.totalNumber;
                let page = 1;
                if (total > 0) {
                    page = this.pager.current.setTotal(total);
                } else {
                    this.pager.current.setTotal(0);
                }
                start = (page - 1) * this.state.objTable.length;
            }
            this.dataStruct.rowsNumber = start;
            if (resTable.hasOwnProperty("data")) {
                let data = resTable["data"];
                if (Array.isArray(data)) {
                    this.data = data;
                    if(this.props.isCustomVeiw){
                        if (this.props.funCustomVeiw instanceof Function) { 
                            this.props.funCustomVeiw(data, this.dataStruct, this.props.recordKeyName, this.HselectItemClick);
                        }
                    }else{ 
                        this.addData(data, this.dataStruct, this.props.recordKeyName, this.HselectItemClick);
                    }
                }
            }
            this.setState((prevState) => ({
                resultText: "",
                resultState: "ready",
                objTable: {...prevState.objTable, start: start}
            }));
        }
    }

    getData(arr){
        let data=[];
        let l=this.data.length;
        let k=this.props.recordKeyName;
        let j=0;
        let l2=arr.length;
        for (let i = 0; i < l; i++) {
            for ( j = 0; j < l2; j++) {
                if(this.data[i][k].toString()===arr[j].toString()){
                    data.push(this.data[i]);
                }
            }
        }
        return data;
    }

    addData(data,ts,recordKeyName ,selectFun=null) {
        ts.rows=[];
        let l=data.length; 
        for (let i=0;i<l;i++){
            this.addRecordData(data[i],ts,data[i][recordKeyName],selectFun);
        } 
    }

    getBoxItem(record) {
        let f = this.props.getBoxItem;
        if (f !== null) {
            if (f instanceof Function) {
                return f(record);
            }
        }
        return null;
    }

    addRecordData(record,ts,recordKey,selectFun=null) {
        ts.rowsId++;
        let v=  this.getBoxItem(record);

        let links=null;
        if (this.props.selectable)  {
            console.log(this.linksChilds);
            if(!Interface.isNull(this.linksChilds)) {
                if (this.linksChilds.length() > 0) {
                    links = <XDiv className="item-links">
                        <CheckBox className="checkbox-default selector" hasLabel={false} onChange={selectFun}/>
                        {this.linksChilds}
                    </XDiv>;
                }
            }
        }

        let el=  <XDiv  className={this.props.classBoxName} itemId={ts.rowsId} key={ts.rowsId} recordKey={recordKey}>
            {v} {links} </XDiv>;
        ts.rows.push(el);
    }

    componentDidMount(){
        switch (this.state.resultState) {
            case "first":
                if(this.props.isHeader) {
                    new DropDown(this.selectLength.current);
                }
                this.setState({resultText:"درحال بارگزاری",resultState:"loading"});
                this.getLoadData();
                let name=this.props.name;
                let scope=this.props.scope;
                let page = this.context.page;
                if(name !== null && name !== '') {
                    if(scope !== null && scope !== '') {
                        page.dispatcher.add(scope,name,"filters",this.HsearchClick);
                    }
                }
                page.dispatcher.add(scope,name,"inserted",this.Hrefresh);
                page.dispatcher.add(scope,name,"edited",this.Hrefresh);
                page.dispatcher.add(scope,name,"deleted",this.Hrefresh);
                page.dispatcher.add(scope,name,"refresh",this.Hrefresh);

                TableManager.initFilters(this.props.listFilters,this.dataStruct,this.HcloseFilter);
                break;
            default:  break;
        }
    }

    componentDidUpdate(){
        switch (this.state.resultState) {
            case "refresh":
                this.setState({resultText:"درحال بارگزاری",resultState:"loading"});
                this.getLoadData();
                break;
            default:  break;
        }
    }

    render() {
        const {
            //children,
            isCustomVeiw,
            selectable,
            className,classNameLoader,
            isHeader
        } = this.props;

        let cw= className;

        let process=null;
        switch (this.state.resultState) {
            case "loading":
                process=<XDiv  className="process" >
                    <XDiv  className="inline-loader" > <Plane   /></XDiv>
                    <XDiv  className="txt" >{this.state.resultText}  </XDiv>
                </XDiv>;
                break;
            default:  break;
        }

        let fc="filter";
        if(this.dataStruct.filters.length>0){
            fc="filter show animated zoomIn";
        }

        let navLiSEl=null;
        if (selectable)  {
            navLiSEl =<>
                <XLi>
                    <CheckBox hasLabel={false} ref={this.selectAll}   onChange={this.HselectClick}/>
                </XLi>
                <XLi className="nav-item ">
                    <XA className="nav-link" href="#" onClick={this.HrefreshClick}>
                        <XI className="la la-refresh "/>
                    </XA>
                </XLi>
            </> ;
        }
  
        let wrapperRows=null;
        if(isCustomVeiw){
            wrapperRows=this.dataStruct.cv;
        }else{
            wrapperRows=this.dataStruct.rows;
        }

        let Navbar1=null;
        if(isHeader){
            Navbar1=<Navbar className="dataloader-navbar">
                <XUl className="navbar-nav ">
                    {navLiSEl}
                    {this.navbarChilds}
                </XUl>
                <XUl className="navbar-nav mr-auto">
                    {this.excelXLi}
                    <XLi className="nav-item dropdown length" eleRef={this.selectLength} >
                        <XA className="nav-link  dropdown-toggle">
                            <XSpan>
                                تعداد نمایش
                            </XSpan>
                            <XSpan>
                                {this.state.objTable.length}
                            </XSpan>
                        </XA>
                        <XDiv className="dropdown-menu" style={{"width":"80px"}}>
                            <XA className="dropdown-item"   href="#" onClick={this.HlengthClick10}>
                                10
                            </XA>
                            <XA className="dropdown-item"   href="#" onClick={this.HlengthClick25}>
                                25
                            </XA>
                            <XA className="dropdown-item"  href="#" onClick={this.HlengthClick50}>
                                50
                            </XA>
                            <XA className="dropdown-item"   href="#" onClick={this.HlengthClick100}>
                                100
                            </XA>
                        </XDiv>
                    </XLi>
                </XUl>
            </Navbar>;
        }

        let cl="dataloader " +classNameLoader;
        return (
            <React.Fragment>
                    <XDiv className={cl} >
                        <XDiv className="header">
                            {Navbar1}
                            <XDiv className={fc}>
                                <XDiv >
                                    {this.dataStruct.filters}
                                </XDiv>
                                <XI className="la la-close" onClick={this.HcloseFilters} />
                            </XDiv>
                        </XDiv>
                        <XDiv className={cw} eleRef={this.wrapper}>
                           {wrapperRows}
                        </XDiv>
                        <XDiv className="row">
                            <XDiv className="col-sm-12 col-md-12 col-xl-12 col-lg-12">
                                <Pagination  changFun={this.HpageClick}  ref={this.pager}/>
                            </XDiv>
                        </XDiv>
                        {process}
                    </XDiv>
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }
        this.data=[];
        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

DataLoader.propTypes = {
    getBoxItem: PropTypes.func,
    classNameLoader:PropTypes.string,
    srcName:PropTypes.string,
    queryFields:PropTypes.string,
    queryArgs:PropTypes.string,
    queryFilters:PropTypes.string,
    listFilters:PropTypes.object,
    className: PropTypes.string,
    classBoxName: PropTypes.string,
    pageAlerts:PropTypes.node,
    orderColumn: PropTypes.number,
    orderDir: PropTypes.number,
    scope: PropTypes.string,
    name: PropTypes.string,
    recordKeyName: PropTypes.string,
    selectable: PropTypes.bool,
    isCustomVeiw: PropTypes.bool,
    funCustomVeiw: PropTypes.func,
    isHeader: PropTypes.bool,
    baseUrl: PropTypes.string,
    excelUrl: PropTypes.string,
    lengthTable :PropTypes.number,
};

DataLoader.defaultProps = {
    className:"wrapperDL",
    classBoxName:"data-item-box",
    classNameLoader:"",
    queryFilters:"",
    listFilters:{},
    pageAlerts:null,
    orderColumn:0,
    orderDir:1,
    scope:"",
    name:"",
    recordKeyName:"id",
    selectable:true,
    isCustomVeiw: false,
    funCustomVeiw: null,
    isHeader: true,
    baseUrl:"",
    excelUrl:"",
    lengthTable:10
};

DataLoader.contextType = MCbrowser;

export default DataLoader;

